<template>
  <div>
    <PartnerHeader :img_header="header_image" header="ประวัติการขายสินค้า" link_back="managepos" />

    <v-card elevation="6">
      <div class="ma-4">
        <!-- Checkboxes และ Dropdown สาขา -->
        <v-row class="mb-4">
          <v-col cols="12" md="3">
            <v-checkbox v-model="showWholesale" label="ดูข้อมูลขายส่ง" color="#86bc3a" hide-details
              @change="fetchSalesHistory"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="showWebSales" label="ดูข้อมูลขายหน้า Web" color="#86bc3a" hide-details
              @change="fetchSalesHistory"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="showBranch" label="ดูข้อมูลสาขา" color="#86bc3a" hide-details
              @change="fetchSalesHistory"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-select v-model="selectedBranch" :items="branches" item-text="name" item-value="id" label="เลือกสาขา"
              prepend-icon="mdi-store" color="#86bc3a" hide-details @change="fetchSalesHistory"></v-select>
          </v-col>
        </v-row>
        <!-- ฟิลเตอร์วันที่และสินค้า -->
        <v-row class="mb-4">
          <v-col cols="12" md="4">
            <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="startDate" label="วันที่เริ่มต้น *" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" color="#86bc3a"
                  :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่มต้น']"></v-text-field>
              </template>
              <v-date-picker v-model="startDate" @input="startDateMenu = false" color="#86bc3a"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="endDate" label="วันที่สิ้นสุด *" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" color="#86bc3a"
                  :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุด']"></v-text-field>
              </template>
              <v-date-picker v-model="endDate" @input="endDateMenu = false" color="#86bc3a"
                :min="startDate"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-col cols="12" md="12">
          <v-autocomplete v-model="selectedProducts" :items="products" item-text="name" item-value="id"
            label="เลือกสินค้า" prepend-icon="mdi-package-variant" color="#86bc3a" hide-details multiple chips
            small-chips deletable-chips clearable class="w-100" @change="fetchSalesHistory">
            <template v-slot:selection="{ item }">
              <v-chip small close @click:close="removeProduct(item.id)" color="#86bc3a" text-color="white">
                {{ item.name }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <!-- ช่องค้นหา -->
        <v-card-title class="px-0">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="ค้นหา" color="#86bc3a" single-line
            hide-details></v-text-field>
        </v-card-title>

        <!-- Loading -->
        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="#86bc3a"></v-progress-circular>
          <div class="mt-2">กำลังโหลดข้อมูล...</div>
        </div>

        <v-data-table v-else :headers="headers" :items="filteredSalesData" :footer-props="footerProps" :search="search"
          mobile-breakpoint="0" class="mt-4" hide-default-header>

          <template v-slot:header>
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th class="text-left pa-3">วันที่เอกสาร</th>
                <th class="text-left pa-3">ชื่อสินค้า</th>
                <th class="text-left pa-3">ชื่อสมาชิก</th>
                <th class="text-left pa-3">หน่วยนับ</th>
                <th class="text-left pa-3">เลขที่เอกสาร</th>
                <th class="text-right pa-3">จำนวนลด</th>
              </tr>
            </thead>
          </template>

          <template v-slot:item="{ item }">
            <!-- แถวหัวกลุ่ม (รหัสสินค้า) -->
            <tr v-if="item.isGroup" style="background-color: #fafafa; font-weight: bold;">
              <td class="pa-2">{{ item.productCode }}</td>
              <td class="pa-2">{{ item.productName }}</td>
              <td colspan="4"></td>
            </tr>

            <!-- แถวข้อมูลย่อย -->
            <tr v-else-if="!item.isTotal" style="background-color: #ffffff;">
              <td class="pa-2">{{ item.documentDate }}</td>
              <td class="pa-2">
                <span>{{ item.documentType }}</span>
                <span v-if="item.note" style="color: red; display: block;">{{ item.note }}</span>
              </td>
              <td class="pa-2">{{ item.name }}</td>
              <td class="pa-2">{{ item.unit }}</td>
              <td class="pa-2">{{ item.documentNumber }}</td>
              <td class="pa-2 text-right">{{ item.quantity }}</td>
            </tr>

            <!-- แถวรวมจำนวน -->
            <tr v-if="item.isTotal" style="background-color: #ffffff; font-weight: bold;" class="total-row">
              <td colspan="5" class="pa-2 text-right">รวมจำนวนลดต่อสินค้า</td>
              <td class="pa-2 text-right">{{ item.totalQuantity }}</td>
            </tr>
          </template>

          <!-- กรณีไม่มีข้อมูล -->
          <template v-slot:no-data>
            <div class="text-center pa-4">
              {{ noDataMessage }}
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/arin_assets/analysis.png";
import axios from 'axios';

export default {
  name: "SalesHistory",
  components: {
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      search: '',
      showWholesale: false,
      showWebSales: false,
      showBranch: false,
      selectedBranch: null,
      selectedProducts: [],
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      loading: false,
      footerProps: {
        'items-per-page-text': 'รายการต่อหน้า',
        'items-per-page-options': [10, 20, 50, 100, -1]
      },
      branches: [],
      products: [],
      headers: [
        { text: 'วันที่เอกสาร', value: 'productCode', sortable: false },
        { text: 'ชื่อสินค้า', value: 'productName', sortable: false, width: '200px' },
        { text: 'ประเภทการขาย', value: 'documentType', sortable: false },
        { text: 'ชื่อสมาชิก', value: 'name', sortable: false },
        { text: 'หน่วยนับ', value: 'unit', sortable: false },
        { text: 'เลขที่เอกสาร', value: 'documentNumber', sortable: false },
        { text: 'จำนวนลด', value: 'quantity', sortable: false, align: 'end' },
      ],
      salesGroups: []
    }
  },
  computed: {
    filteredSalesData() {
      let result = [];

      this.salesGroups.forEach(group => {
        // เพิ่มแถวหัวกลุ่ม
        result.push({
          isGroup: true,
          productCode: group.productCode,
          productName: group.productName
        });

        // เพิ่มแถวข้อมูลย่อย
        group.items.forEach(item => {
          result.push({
            isGroup: false,
            isTotal: false,
            ...item
          });
        });

        // คำนวณรวมจำนวน
        const totalQuantity = group.items.reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);

        // เพิ่มแถวรวม
        result.push({
          isTotal: true,
          totalQuantity: totalQuantity.toFixed(2)
        });
      });

      return result;
    },
    noDataMessage() {
      if (!this.startDate || !this.endDate) {
        return 'กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด';
      }
      if (!this.showWholesale && !this.showWebSales && !this.showBranch) {
        return 'กรุณาเลือกประเภทข้อมูลที่ต้องการดู';
      }
      return 'ไม่พบข้อมูล';
    }
  },
  watch: {
    startDate(newVal) {
      if (newVal && this.endDate && newVal > this.endDate) {
        alert('วันที่เริ่มต้นต้องน้อยกว่าหรือเท่ากับวันที่สิ้นสุด');
        this.startDate = null;
      } else if (newVal && this.endDate) {
        this.fetchSalesHistory();
      }
    },
    endDate(newVal) {
      if (newVal && this.startDate && newVal < this.startDate) {
        alert('วันที่สิ้นสุดต้องมากกว่าหรือเท่ากับวันที่เริ่มต้น');
        this.endDate = null;
      } else if (newVal && this.startDate) {
        this.fetchSalesHistory();
      }
    }
  },
  mounted() {
    // ตั้งค่าวันที่เริ่มต้นและสิ้นสุดเป็นเดือนปัจจุบัน
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = firstDay.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);

    this.fetchBranches();
    this.fetchProducts();
    this.fetchSalesHistory();
  },
  methods: {
    async fetchBranches() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/sales-history/branches`);
        if (response.data.success) {
          this.branches = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
        alert('ไม่สามารถโหลดข้อมูลสาขาได้');
      }
    },
    async fetchProducts() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/sales-history/products`);
        if (response.data.success) {
          this.products = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        alert('ไม่สามารถโหลดข้อมูลสินค้าได้');
      }
    },
    async fetchSalesHistory() {
      // ตรวจสอบว่ากรอกวันที่ครบหรือไม่
      if (!this.startDate || !this.endDate) {
        this.salesGroups = [];
        return;
      }

      // ถ้าไม่ได้เลือกอะไรเลย ให้ล้างข้อมูล
      if (!this.showWholesale && !this.showWebSales && !this.showBranch) {
        this.salesGroups = [];
        return;
      }

      this.loading = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/sales-history/all`, {
          params: {
            show_wholesale: this.showWholesale,
            show_web_sales: this.showWebSales,
            show_branch: this.showBranch,
            selected_branch: this.selectedBranch,
            selected_products: this.selectedProducts.join(','),
            start_date: this.startDate,
            end_date: this.endDate
          }
        });

        if (response.data.success) {
          this.salesGroups = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching sales history:', error);
        if (error.response && error.response.data) {
          console.error('Error details:', error.response.data);
          alert('เกิดข้อผิดพลาด: ' + (error.response.data.message || 'ไม่สามารถโหลดข้อมูลได้'));
        } else {
          alert('เกิดข้อผิดพลาด: ไม่สามารถโหลดข้อมูลประวัติการขายได้');
        }
      } finally {
        this.loading = false;
      }
    },
    removeProduct(productId) {
      const index = this.selectedProducts.indexOf(productId);
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
        this.fetchSalesHistory();
      }
    },
  }
}
</script>

<style scoped>
::v-deep .v-data-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}

::v-deep .v-data-table tbody tr.total-row {
  border-top: none !important;
}

::v-deep .v-data-table tbody tr.total-row td {
  padding-bottom: 16px !important;
}
</style>